import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'

class OrderCreatedEvent extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            object: this.props.object || null,
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            object: nextProps.object || null,
        })
    }

    render() {
        return <div className={"row " + this.state.className}>
            <div className="col-12">
                <FormattedMessage
                    id="order.analytics.events.order_created_text"
                    defaultMessage="Order {identifier} has been created"
                    values={{
                        identifier: this.state.object.attributes.identifier
                    }}
                />
            </div>
        </div>
    }

}

export default OrderCreatedEvent





// WEBPACK FOOTER //
// ./src/quote/analytics/events/order-created.component.jsx